import { FieldValidator } from "final-form";
import { ChangeEvent, FC, ReactElement } from "react";
import { Field } from "react-final-form";
import Checkbox from "@Components/ui/checkbox/Checkbox";

interface Props {
  name: string;
  className?: string;
  isChecked?: boolean;
  disabled?: boolean;
  id: string;
  label?: string | ReactElement;
  validate?: FieldValidator<string>;
  onChange?: (e: ChangeEvent) => void;
}

const CheckBoxField: FC<Props> = ({
  name,
  className,
  isChecked = false,
  disabled = false,
  id,
  label,
  validate,
  onChange,
  ...restProps
}) => {
  return (
    <Field name={name} validate={validate}>
      {({ input }) => (
        <Checkbox
          {...input}
          {...restProps}
          className={className}
          id={id}
          label={label}
          isChecked={isChecked}
          disabled={disabled}
          handleOnChange={(value: ChangeEvent) => {
            onChange?.(value);
            input?.onChange?.(value);
          }}
        />
      )}
    </Field>
  );
};

export default CheckBoxField;
